import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataMediaRisksState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataMediaRisksReducer.staticDataMediaRisksFeatureKey]
);

export const getStaticDataMediaRisksFailure = createSelector(
  getStaticDataMediaRisksState,
  staticDataCountriesReducer.fromStaticDataMediaRisksReducer.getMediaRisksError
);

export const getStaticDataMediaRisksResponse = createSelector(
  getStaticDataMediaRisksState,
  staticDataCountriesReducer.fromStaticDataMediaRisksReducer.getMediaRisks
);
